import type { Dispatch, SetStateAction } from 'react'

import { FvButton } from '@fv/client-components'

import { DividedContent } from '@/components/DividedContent'
import { TabLink } from '@/components/TabLink'

type Props = {
  closePanel: () => void
  isViewingSentList: boolean
  setViewingSentList: Dispatch<SetStateAction<boolean>>
}

const PanelNav = ({
  closePanel,
  isViewingSentList,
  setViewingSentList,
}: Props) => {
  return (
    <DividedContent>
      <FvButton icon="arrow-to-left" onClick={closePanel}>
        Back
      </FvButton>
      <TabLink
        icon="envelope"
        isActive={!isViewingSentList}
        onClick={() => setViewingSentList(false)}
      >
        Have not sent
      </TabLink>
      <TabLink
        icon="envelope-open"
        isActive={isViewingSentList}
        onClick={() => setViewingSentList(true)}
      >
        Have sent
      </TabLink>
    </DividedContent>
  )
}

export default PanelNav
